import React, { useState } from "react";
import ProfileAvatar from "../../../components/globalFunctions/globalFunctions";

const AllStudents = () => {
  const studentList = [
    {
      studentId: "STU001",
      fullName: "John Carter",
      email: "john.carter@example.com",
      phone: "+1-555-222-0101",
      lmsSource: "Moodle",
      enrolledCoursesCount: 5,
      completionPercentage: 78,
      lastActivityDate: "2025-01-20",
      status: "Active",
    },
    {
      studentId: "STU002",
      fullName: "Emily Watson",
      email: "emily.watson@example.com",
      phone: "+1-555-222-0102",
      lmsSource: "Canvas",
      enrolledCoursesCount: 3,
      completionPercentage: 92,
      lastActivityDate: "2025-01-18",
      status: "Active",
    },
    {
      studentId: "STU003",
      fullName: "Michael Brown",
      email: "michael.brown@example.com",
      phone: "+1-555-222-0103",
      lmsSource: "Blackboard",
      enrolledCoursesCount: 4,
      completionPercentage: 65,
      lastActivityDate: "2025-01-15",
      status: "Active",
    },
    {
      studentId: "STU004",
      fullName: "Sophia Johnson",
      email: "sophia.johnson@example.com",
      phone: "+1-555-222-0104",
      lmsSource: "Moodle",
      enrolledCoursesCount: 6,
      completionPercentage: 88,
      lastActivityDate: "2025-01-22",
      status: "Active",
    },
    {
      studentId: "STU005",
      fullName: "Daniel Lee",
      email: "daniel.lee@example.com",
      phone: "+1-555-222-0105",
      lmsSource: "Canvas",
      enrolledCoursesCount: 2,
      completionPercentage: 40,
      lastActivityDate: "2025-01-10",
      status: "Inactive",
    },
    {
      studentId: "STU006",
      fullName: "Olivia Martinez",
      email: "olivia.martinez@example.com",
      phone: "+1-555-222-0106",
      lmsSource: "Blackboard",
      enrolledCoursesCount: 7,
      completionPercentage: 95,
      lastActivityDate: "2025-01-25",
      status: "Completed",
    },
    {
      studentId: "STU007",
      fullName: "William Anderson",
      email: "william.anderson@example.com",
      phone: "+1-555-222-0107",
      lmsSource: "Moodle",
      enrolledCoursesCount: 1,
      completionPercentage: 20,
      lastActivityDate: "2025-01-05",
      status: "Inactive",
    },
    {
      studentId: "STU008",
      fullName: "Ava Thompson",
      email: "ava.thompson@example.com",
      phone: "+1-555-222-0108",
      lmsSource: "Canvas",
      enrolledCoursesCount: 4,
      completionPercentage: 70,
      lastActivityDate: "2025-01-19",
      status: "Active",
    },
    {
      studentId: "STU009",
      fullName: "James Wilson",
      email: "james.wilson@example.com",
      phone: "+1-555-222-0109",
      lmsSource: "Blackboard",
      enrolledCoursesCount: 3,
      completionPercentage: 55,
      lastActivityDate: "2025-01-14",
      status: "Active",
    },
    {
      studentId: "STU010",
      fullName: "Isabella Moore",
      email: "isabella.moore@example.com",
      phone: "+1-555-222-0110",
      lmsSource: "Moodle",
      enrolledCoursesCount: 5,
      completionPercentage: 83,
      lastActivityDate: "2025-01-21",
      status: "Active",
    },
    {
      studentId: "STU011",
      fullName: "Benjamin Taylor",
      email: "benjamin.taylor@example.com",
      phone: "+1-555-222-0111",
      lmsSource: "Canvas",
      enrolledCoursesCount: 6,
      completionPercentage: 90,
      lastActivityDate: "2025-01-23",
      status: "Active",
    },
    {
      studentId: "STU012",
      fullName: "Mia Harris",
      email: "mia.harris@example.com",
      phone: "+1-555-222-0112",
      lmsSource: "Blackboard",
      enrolledCoursesCount: 2,
      completionPercentage: 35,
      lastActivityDate: "2025-01-08",
      status: "Inactive",
    },
    {
      studentId: "STU013",
      fullName: "Lucas Clark",
      email: "lucas.clark@example.com",
      phone: "+1-555-222-0113",
      lmsSource: "Moodle",
      enrolledCoursesCount: 8,
      completionPercentage: 97,
      lastActivityDate: "2025-01-26",
      status: "Completed",
    },
    {
      studentId: "STU014",
      fullName: "Charlotte Lewis",
      email: "charlotte.lewis@example.com",
      phone: "+1-555-222-0114",
      lmsSource: "Canvas",
      enrolledCoursesCount: 3,
      completionPercentage: 60,
      lastActivityDate: "2025-01-16",
      status: "Active",
    },
    {
      studentId: "STU015",
      fullName: "Henry Walker",
      email: "henry.walker@example.com",
      phone: "+1-555-222-0115",
      lmsSource: "Blackboard",
      enrolledCoursesCount: 4,
      completionPercentage: 72,
      lastActivityDate: "2025-01-17",
      status: "Active",
    },
    {
      studentId: "STU016",
      fullName: "Amelia Hall",
      email: "amelia.hall@example.com",
      phone: "+1-555-222-0116",
      lmsSource: "Moodle",
      enrolledCoursesCount: 5,
      completionPercentage: 85,
      lastActivityDate: "2025-01-24",
      status: "Active",
    },
    {
      studentId: "STU017",
      fullName: "Ethan Allen",
      email: "ethan.allen@example.com",
      phone: "+1-555-222-0117",
      lmsSource: "Canvas",
      enrolledCoursesCount: 2,
      completionPercentage: 45,
      lastActivityDate: "2025-01-11",
      status: "Inactive",
    },
    {
      studentId: "STU018",
      fullName: "Harper Young",
      email: "harper.young@example.com",
      phone: "+1-555-222-0118",
      lmsSource: "Blackboard",
      enrolledCoursesCount: 6,
      completionPercentage: 89,
      lastActivityDate: "2025-01-22",
      status: "Active",
    },
    {
      studentId: "STU019",
      fullName: "Noah King",
      email: "noah.king@example.com",
      phone: "+1-555-222-0119",
      lmsSource: "Moodle",
      enrolledCoursesCount: 1,
      completionPercentage: 15,
      lastActivityDate: "2025-01-03",
      status: "Inactive",
    },
    {
      studentId: "STU020",
      fullName: "Lily Scott",
      email: "lily.scott@example.com",
      phone: "+1-555-222-0120",
      lmsSource: "Canvas",
      enrolledCoursesCount: 7,
      completionPercentage: 93,
      lastActivityDate: "2025-01-25",
      status: "Active",
    },
  ];

  const [selectedIds, setSelectedIds] = useState([]);

  const handleRowSelect = (e, id) => {
    if (e.target.checked) {
      setSelectedIds((prev) => [...prev, id]);
    } else {
      setSelectedIds((prev) => prev.filter((item) => item !== id));
    }
  };

  const handleRefresh = () => {
    setSelectedIds([]); // uncheck all rows
    localStorage.removeItem("selectedStudents"); // optional
  };

  const renderView = () => {
    return studentList.map((student) => (
      <tr key={student.studentId}>
        <td style={{ width: "10px", paddingRight: "0" }}>
          <div className="form-check">
            <input type="checkbox" className="form-check-input" checked={selectedIds.includes(student.studentId)} onChange={(e) => handleRowSelect(e, student.studentId)} />
          </div>
        </td>
        <td>
          <div className="d-flex align-items-center user-title">
            <i className="profile-pic">
              <ProfileAvatar name={student.fullName} />
            </i>
            <span className="text-dark fw-medium ">{student.fullName}</span>
          </div>
        </td>
        <td>
          <a href={`mailto:${student.email}`}>{student.email}</a>
        </td>
        <td>
          <a href={`tel:${student.phone}`}>{student.phone}</a>
        </td>
        <td style={{ paddingLeft: "25px" }}>{student.enrolledCoursesCount}</td>
        <td>
          {student.status}
          {/* <span className={`badge ${student.status === "Active" ? "bg-success" : student.status === "Completed" ? "bg-warning" : student.status === "Inactive" ? "bg-primary" : "bg-secondary"}`}>
            {student.status}
          </span> */}
        </td>
        <td>{student.lastActivityDate}</td>

        {/* <div>
          <button className="btn btn-sm btn-primary me-2">
            <i class="ri-edit-line"></i>
          </button>
          <button className="btn btn-sm btn-primary me-2">
            <i class="ri-eye-line"></i>
          </button>
          <button className="btn btn-sm btn-danger">
            <i class="ri-delete-bin-line"></i>
          </button>
        </div> */}
      </tr>
    ));
  };

  return (
    <div className="page-content student-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0">Learners List ({studentList.length})</h4>
              <div className="page-title-box-content">
                {selectedIds.length > 0 && (
                  <>
                    {selectedIds.length === 1 && (
                      <button className="page-title-box-btn">
                        <i className="ri-edit-line"></i>
                      </button>
                    )}
                    <button className="page-title-box-btn">
                      <i className="ri-delete-bin-line"></i>
                    </button>
                  </>
                )}
                <button type="button" className="page-title-box-btn" onClick={handleRefresh}>
                  <i className="ri-refresh-line"></i>
                </button>
                <form className="app-search">
                  <div className="position-relative">
                    <input type="search" className="form-control" placeholder="Search..." autoComplete="off" name="searchValue" />
                    <i className="ri-search-line search-widget-icon"></i>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="table-responsive">
                <table className="table align-middle text-nowrap table-hover table-small">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th style={{ width: "10px", paddingRight: "0" }}>
                        <div className="form-check">
                          <input type="checkbox" className="form-check-input" />
                          <label className="form-check-label"></label>
                        </div>
                      </th>
                      <th style={{ width: "500px" }}>Name</th>
                      <th style={{ width: "400px" }}>Email</th>
                      <th style={{ width: "300px" }}>Phone</th>
                      <th>Courses Registered</th>
                      <th>Status</th>
                      <th>Last Activity Date</th>
                    </tr>
                  </thead>
                  <tbody>{renderView()}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllStudents;
